import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=6e569b9f&scoped=true&"
import script from "./policyDetail.vue?vue&type=script&lang=js&"
export * from "./policyDetail.vue?vue&type=script&lang=js&"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=6e569b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e569b9f",
  null
  
)

export default component.exports